import React from "react";
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import ScrollToTop from "./ScrollToTop";
import Navbar from "./Navbar";
import Home from './Home';
import Brands from './Brands';
import Inventory from './Inventory';
import Compare from './Compare';
import Reviews from './Reviews';
import Contact from './Contact';
import Footer from './Footer';
import BrandDetail from "./BrandDetail";
import BoatTail from "./BoatTail";
import PaganiZonda from "./PaganiZonda";
import LaRoseNoire from "./LaRoseNoire";

function App() {
    useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://example.com/script.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Navbar logoSrc="/carzoo-logo.png" />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/brand/:brand" element={<BrandDetail />} />
        <Route path="/boat-tail" element={<BoatTail />} />
        <Route path="/pagani-zonda" element={<PaganiZonda />} />
        <Route path="/la-rose-noire" element={<LaRoseNoire />} />
      </Routes>

      <Footer logoSrc="/carzoo-logo.png" />
    </BrowserRouter>
  );
}

export default App;
